

export class QRCodeGenerator {
    baseUrl: string;
    argumentContent: string;
}
 

export class CouponGenerator {
    price: number;
    amount: number;
    merCode: string;
}
 